import React, { Component } from 'react';
import { Card, message, Tree } from 'antd';
import { queryWorkOrg } from '@api/hr/workOrg';

const { TreeNode } = Tree;

class TreeOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gData: [],
      dataList: [],
      searchValue: '',
      expandedKeys: [],
      selectedKeys: [],
    };
  }

  componentDidMount() {
    this.getWorkOrg();
  }

  componentWillReceiveProps(nextProps) {
    const { workOrgUuid } = nextProps;
    const { gData } = this.state;
    if (workOrgUuid !== this.props.workOrgUuid && gData.length === 0) {
      queryWorkOrg().then(res => {
        if (res.statusCode === 200) {
          let expandedKeys = [];
          expandedKeys = expandedKeys.concat(this.getParentKey(workOrgUuid, res.data));
          this.generateList(res.data);

          this.setState({
            gData: res.data,
            selectedKeys: [workOrgUuid],
            expandedKeys,
          });
        } else {
          message.error(res.message);
        }
      });
    }
  }

  // 获取组织架构
  getWorkOrg = () => {
    queryWorkOrg().then(res => {
      if (res.statusCode === 200) {
        this.generateList(res.data);
        this.setState({
          gData: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 设置组织架构
  generateList = data => {
    const { dataList } = this.state;
    data.map(item => {
      dataList.push({ uuid: item.uuid, name: item.name });
      if (item.children) {
        this.generateList(item.children);
      }
      return item;
    });
  };

  // 找到该目录的所有父级目录（及以上）
  getParentKey = (key, tree, grandKeys) => {
    let parentKey;
    const grandKey = grandKeys || [];
    tree.map(item => {
      if (item.children) {
        if (item.children.some(item1 => item1.uuid === key)) {
          grandKey.push(item.uuid);
          parentKey = grandKey;
        } else if (this.getParentKey(key, item.children)) {
          grandKey.push(item.uuid);
          parentKey = this.getParentKey(key, item.children, grandKey);
        }
      }
      return item;
    });
    return parentKey;
  };

  onSelect = (selectedKeys, e) => {
    this.setState({
      selectedKeys,
    });
    this.props.onSelect({
      uuid: e.selected ? e.node.props.dataRef.uuid : '',
      name: e.selected ? e.node.props.dataRef.name : '',
    });
  };

  onChange = value => {
    const { gData, dataList } = this.state;
    const parentKeys = dataList
      .map(item => {
        if (item.name.indexOf(value) > -1) {
          const parentKey = this.getParentKey(item.uuid, gData);
          return parentKey ? parentKey.join('*') : null;
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);

    let expandedKeys = [];
    parentKeys.map(item => {
      expandedKeys = expandedKeys.concat(item.split('*'));
      return item;
    });
    expandedKeys = expandedKeys.filter((item, i, self) => item && self.indexOf(item) === i);
    this.setState({
      searchValue: value,
      expandedKeys,
    });
  };

  onExpand = expandedKeys => {
    this.setState({
      expandedKeys,
    });
  };

  render() {
    const { searchValue, selectedKeys, expandedKeys } = this.state;
    const loop = data =>
      data.map(item => {
        const index = item.name.indexOf(searchValue);
        const beforeStr = item.name.substr(0, index);
        const afterStr = item.name.substr(index + searchValue.length);
        const title =
          index > -1 ? (
            <span>
              {beforeStr}
              <span style={{ color: '#f50' }}>{searchValue}</span>
              {afterStr}
            </span>
          ) : (
            <span>{item.name}</span>
          );
        if (item.children) {
          return (
            <TreeNode key={item.uuid} title={title} dataRef={item}>
              {loop(item.children)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.uuid} title={title} dataRef={item} />;
      });
    return (
      <div>
        {/* <Row type="flex" justify="end" style={{ marginBottom: "16px" }}>
          <Col>
            <Search
              placeholder="输入关键字搜索"
              onSearch={this.onChange}
              style={{ width: 200 }}
            />
          </Col>
        </Row> */}
        <Card>
          <Tree
            showLine
            onExpand={this.onExpand}
            expandedKeys={expandedKeys}
            onSelect={this.onSelect}
            selectedKeys={selectedKeys}
          >
            {loop(this.state.gData)}
          </Tree>
        </Card>
      </div>
    );
  }
}

export default TreeOrg;



// WEBPACK FOOTER //
// ./src/components/task/TreeOrg.js